<!--
 * @Author: ZS
 * @Date: 2020-06-09 15:37:50
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-08 11:58:43
 * @Description: file content
-->
<template>
  <div class="header mainWidth clearfix">
    <div class="logo pull-left"
      :style="{ backgroundImage: `url(${sysLogo})` }"
    ></div>
    <div class="topLink pull-right" v-if="false"><a class="green" :href="schoolIndex" target="_Blank">学校首页</a>|
    <template v-if="problemFlag"><a class="green" :href="feedBackUrl" >意见反馈</a>|</template>
      <el-popover placement="bottom" width="240" trigger="hover">
        <div style="text-align:center">
          <img src="../../assets/images/time1.png" alt="" style="widt:80px;height:80px">
          <p style="line-height:36px;color:#666666">即将上线敬请期待~</p>
        </div>
        <a class="green" href="javascript:;" slot="reference">APP下载</a>
      </el-popover><span id="topLogin" v-if="!$store.state.isLogin">|<a class="green" href="javascript:;"
          @click="login(0)">登录</a></span><span id="logout" v-if="$store.state.isLogin">|<a class="green"
          href=" javascript:;" @click="login(1)">退出登录</a></span>
    </div>
  </div>
</template>

<script>
  import { request } from '@/api/axios'
  export default {
    data() {
      return {
        // 学校首页
        schoolIndex: "",
        // 系统logo
        sysLogo: "",
        // feedBackUrl: "http://campus.zzuli.edu.cn/portal-pc/pc/qy/feedBack/feedBack.html"
        feedBackUrl: "feedBack",
        problemFlag: true
      }
    },
    created() {
      this.getSysLogoAndIndex();
    },
    methods: {
      /**
       * @name getSysLogoAndIndex
       * @description 获取系统logo和学校首页地址
       * @param {}
       * @return {}
       * @author cjs1992
       * @date 2020-08-06 14:59:29
       */
      async getSysLogoAndIndex() {
        request({
          method: "get",
          url: "/portal-ywtb/web/portalPcGuidelineWebsiteInfo/findPortalPcGuidelineWebsiteInfoList"
        }).then((res) => {
          if (res && res.dataList && res.dataList[0]) {
            const { pcGuidelineWebsiteInfoImg, pcGuidelineWebsiteInfoUrl } = res.dataList[0];
            this.schoolIndex = pcGuidelineWebsiteInfoUrl;
            this.sysLogo = '/portal-ywtb/public/getImg?path=' + window.encodeURIComponent(pcGuidelineWebsiteInfoImg);
            this.$store.commit("changeWebInfo", res.dataList[0]);
          }
        }).catch((err) => {})
      },
    },
    mounted() {
      // this.$store.commit('changeLogin')
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/workbench/header.vue